import moment from 'moment';

function registerHandlebarsHelpers(Handlebars) {
  const MULTIPLIER = Math.pow(10, 11);

  const helpers = {
    add                         : add,
    subtract                    : subtract,
    compare                     : compare,
    divide                      : divide,
    filter                      : filter,
    escapeDoubleQuotes          : escapeDoubleQuotes,
    formatTimeTZ                : formatTimeTZ,
    multiply                    : multiply,
    parseFloat                  : parseFloat,
    toFixed                     : toFixed,
    toFloat                     : toFloat,
    escape                      : escape,
    substring                   : substring,
    padStart                    : padStart,
    split                       : split,
    join                        : join,
    trimText                    : trimText,
    getArrayIndex               : getArrayIndex,
  };

  for (let name in helpers) {
    if (helpers.hasOwnProperty(name)) {
      Handlebars.registerHelper(name, helpers[name]);
    }
  }

  function add(a, b) {
    return (Math.round(toFloat(a) * MULTIPLIER) + Math.round(toFloat(b) * MULTIPLIER)) / MULTIPLIER;
  }

  function subtract(a, b) {
    return (Math.round(toFloat(a) * MULTIPLIER) - Math.round(toFloat(b) * MULTIPLIER)) / MULTIPLIER;
  }

  function compare(a, operator, b, options) {

    if (arguments.length < 4) {
      throw new Error('handlebars Helper {{compare}} expects 4 arguments');
    }

    if (typeof a === 'boolean' || typeof b === 'boolean') {
      a = String(a);
      b = String(b);
    }

    let result;
    switch (operator) {
      case '==':
        // eslint-disable-next-line
        result = a == b;
        break;
      case '===':
        result = a === b;
        break;
      case '!=':
        // eslint-disable-next-line
        result = a != b;
        break;
      case '!==':
        result = a !== b;
        break;
      case '<':
        result = a < b;
        break;
      case '>':
        result = a > b;
        break;
      case '<=':
        result = a <= b;
        break;
      case '>=':
        result = a >= b;
        break;
      case 'typeof':
        result = typeof a === b;
        break;
      default: {
        throw new Error('helper {{compare}}: invalid operator: `' + operator + '`');
      }
    }

    if (result === false) {
      return options.inverse(this);
    }
    return options.fn(this);
  }

  function divide(a, b) {
    return a / b;
  }

  function escapeDoubleQuotes(variable) {
    if (!variable) {
      return variable;
    } else {
      return variable.replace(/(["])/g, '\\$1');
    }
  }

  function filter(array, json){
    json = JSON.parse(json);

    return array.filter(function(obj){
      let test = false;

      for (let prop in json) {
        test = obj.hasOwnProperty(prop) && obj[prop] === json[prop];

        if (!test) {
          return false;
        }
      }

      return test;
    });
  }

  function formatTimeTZ(date, format, timezone) {
    return moment(date).tz(timezone).format(format);
  }

  function multiply(a, b) {
    return (Math.round(toFloat(a) * MULTIPLIER) * Math.round(toFloat(b) * MULTIPLIER)) / (MULTIPLIER * MULTIPLIER);
  }

  function toFixed(number, digits) {
    if (typeof digits === 'undefined') {
      digits = 0;
    }

    return toFloat(number).toFixed(digits);
  }

  function toFloat(number) {
    return parseFloat(number || 0);
  }

  function escape(string = '') {
    return String(string).replace(/#/g, '');
  }

  function substring(string, start, end) {
    return String(string).substring(start, end);
  }

  function padStart(string, maxLength, fillString = '') {
    return String(string).padStart(maxLength, fillString);
  }

  function split(string, separator, options) {
    const parts = String(string).split(separator);
    return parts.map(part => options.fn(part)).join('');
  }

  function join(arr, separator) {
    return [...arr].join(separator);
  }

  function trimText(string) {
    return String(string).trim();
  }

  function getArrayIndex(arr, index) {
    return [...arr][index];
  }
}

export {
  registerHandlebarsHelpers,
};
